import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import MainLayout from "./pages/UserScreens/MainLayout.jsx";
import { useLocation } from "react-router-dom";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  RouterProvider,
} from "react-router-dom";
//Context api
import {
  DistrictBlockSchoolProvider,
  BlockProvider,
  SchoolProvider,
  ClassOfStudentProvider,
  DistrictProvider,
  DistrictBlockSschoolContextV2Provider,
} from "./components/contextAPIs/DependentDropdowns.contextAPI.js";

//UI Components

//Imports of Admin

import UpdateStudent from "./components/AcademicsComponents/UpdateStudent.component.jsx";
import { TemplateLanding } from "./pages/ModularPage/AdminPage.jsx";

//Imports of Users.

import { UserSignIn } from "./components/user/UserSignIn.component.jsx";
import { UserProvider } from "./components/contextAPIs/User.context.js";
import UserLoggedIn from "./components/user/UserLoggedIn.component.jsx";

import { UserAttendance } from "./components/user/UserAttendance.jsx";
import { UserAttendanceLogout } from "./components/user/userAttendanceLogout.jsx";

// Imports of Academics
import AttendanceMB from "./components/AcademicsComponents/AttendanceMB.component.jsx";
import { UploadMarks } from "../src/components/AcademicsComponents/UploadMarks.component.jsx";
import { StudentDisciplinaryOrInteraction } from "./components/AcademicsComponents/StudentDisciplinaryOrInteraction.component.jsx";
import { ManualAttendance } from "./components/AcademicsComponents/ManualAttendance.jsx";

//Import of bills
import Bills from "./components/Bills/Bills.jsx";
import BillsPending from "./components/Bills/BillsPending.jsx";
import BillsVerification from "./components/Bills/BillsVerification.jsx";
import BillsApproval from "./components/Bills/BillsApproval.jsx";
import UserSignup from "./components/user/UserSignup.component.jsx";



//Imports of Centers
import MbCentersDisciplinary from "./components/CentersOrSchools/MbCentersDisciplinary.jsx";
import TestCss from "./components/user/testCss.jsx";

//Attendance pdf
import { AttendancePdf } from "./components/AcademicsComponents/AttendancePdf.component.jsx";
import { DownloadAttendancePdfFormat } from "./components/AcademicsComponents/DownloadAttendancePdfFormat.component.jsx";
import { CenterDisciplinaryData } from "./components/CentersOrSchools/CenterDisciplinaryData.jsx";

import { SliderProvidedr } from "./components/contextAPIs/SliderHook.context.js";


//Template
import { Template } from "./pages/UserScreens/Template.jsx";
import { TestController } from "./components/AcademicsComponents/ExamOrTestController.jsx";
import { CreateTest_Admin } from "./components/AcademicsComponents/CreateTest_Admin.jsx";
import { CreateEmpAttendanceData } from "./Admin/CreateEmpAttendanceData.jsx";
import { CreateStudentAttendanceData } from "./Admin/CreateStudentAttendanceData.jsx";

import { StudentRelatedCallings } from "./Callings/StudentRelatedCallings.jsx";
import { AbsenteeCalling } from "./Callings/AbsenteeCallings.jsx";
import { CreateUploadAttendancePdf } from "./Admin/CreateUploadAttendancePdf.jsx";
// //Practice
// import { Practice } from './practice/pactice.jsx';
import MainLayoutAdmin from "./pages/UserScreens/MainLayoutPhoneAndPc.jsx";

import { CopyChecking } from "./components/AcademicsComponents/CopyChecking.jsx";
import SchoolConcernsForm from "./components/Concern/SchoolConcernsForm.jsx"
import TechConcerns from "./components/Concern/TechConcerns.jsx";
import { UserAttendanceUpdated } from "./components/user/UpdatedUserAttendance.jsx";
import { NewNavbar } from "./components/Navbar/NewNavbar.jsx";
import { Footer } from "./components/Navbar/ErpTestFooter.jsx";
import { AbsentCalling } from "./Callings/AbsentCalling.jsx";
import LayoutWithNewNavbar from "./components/Navbar/LayoutWithNewNavbar.jsx";
import MainLayoutAciLevel from "./pages/UserScreens/MainLayoutAciLevel.jsx";
import { TechConcernsResolution } from "./components/Concern/TechConcernsResolution.jsx";
import { TechConcernsStatus } from "./components/Concern/TechConcernsStatus.jsx";
import SchoolConcerns from "./components/Concern/SchoolConcerns.jsx";
import BillsPage from "./components/Bills/BillsPage.jsx";
import BillsVerificationPage from "./components/Bills/BillsVerificationPage.jsx";
import {IndividualConcernsForm } from "./components/Concern/IndividualConcernsForm.jsx";
import { IndividualConcerns } from "./components/Concern/IndividualConcerns.jsx";
import { IndividualLeaveRequests } from "./components/Concern/IndividualLeaveRequests.jsx";
import { IndividualConcenrsResolution } from "./components/Concern/IndividualConcernsResolutions.jsx";
import { UserAttendanceACI } from "./components/user/UserAttendanceACI.jsx";
import SchoolConcernsRequest from "./components/Concern/SchoolConcernsRequest.jsx";
import { ForgotPassword } from "./components/user/ForgotPassword.jsx";
import MainLayoutManagerLevel from "./pages/UserScreens/MainLayoutManager.jsx";
import OfficeCommunityTeam from "./pages/UserScreens/OfficeCommunityTeam.jsx";
import { StudentAttendanceDashBoard } from "./components/DashBoard/AttendanceDashBoard.jsx";
import { StudentCallingDashBoard } from "./components/DashBoard/CallingDashboards.component.jsx";
import { AttendancePdfCount } from "./components/DashBoard/AttendancePdfCount.component.jsx";
import { UserAttendanceDash } from "./components/user/UserAttendanceDashboard.jsx";
import { UserProfile } from "./components/user/UserProfile.jsx";
import AdminLayout from "./pages/UserScreens/AdminMainLayout.jsx";
import TechConcernsLayout from "./pages/UserScreens/TechConcernsLayout.jsx";
import { StudentDisciplinaryDashboard } from "./components/DashBoard/StudentDisciplinaryDashboard.jsx";
import MainLayoutOfficeLevel from "./pages/UserScreens/MainLayoutOffice.jsx";
import { IndividualConcernsRequest } from "./components/Concern/IndividualConcernsRequest.jsx";
import { BillDashboard } from "./components/Bills/BillDashboard.jsx";
import { GamificationDisciplinary } from "./components/AcademicsComponents/GamificationDisciplinary.compoent.jsx";
import { S100Attendances } from "./components/AcademicsComponents/S100Attendances.component.jsx";

import { CreateUser } from "./Admin/CreateUser.component.jsx";
import { UpdateUser } from "./Admin/UpdateUser.component.jsx";
import { MainBillPage } from "./components/Bills/MainBillPage.jsx";
import VerifiedAndRejectedBills from "./components/Bills/VerifiedAndRejectedBills.jsx";
import { UserMainLayout } from "./pages/UserScreens/UsersMainLayout.jsx";
import { Gamification } from "./components/Gamification/Gamification.jsx";
import { ERPtest } from "./components/ErpTest/ErpTest.jsx";
import { GamificationDashboard } from "./components/Gamification/GamificationDashboard.jsx";
import { StudentTestFileUpload } from "./components/AcademicsComponents/TestFileUploadByStudents.jsx";
import { TaVerification } from "./components/TaVerification/TaVerification.jsx";

import { EditUserAccess } from "./Admin/EditUserAccess.component.jsx";
import { EditUser } from "./Admin/EditUser.component.jsx";
import { Calling } from "./Callings/Calling.jsx";
import { CreateObjectiveOfCalling } from "./Callings/ObjectiveOfCalling.jsx";
import { CallingDashboardByUserId } from "./Callings/CallingDashobardByUserId.jsx";
import { CallingMain } from "./Callings/CallingMain.jsx";
import { AMEScoreCard202527 } from "./components/AcademicsComponents/AMEScoreCard202527.jsx";
import { AMEAttendanceSheet } from "./components/AcademicsComponents/AMEAttendanceSheet.jsx";
import { AMEAdmitCard } from "./components/AcademicsComponents/AMEAdmitCard.jsx";
import { CallingDashboardOfAllUsers } from "./Callings/CallingDashboardOfAllUsers.jsx";
import { MarkUserAttendance } from "./components/user/UserAttendance.v2.jsx";
import { MBStudentsAttendanceV2 } from "./components/Students/MBStudentsAttendance.v2.jsx";
import { DateNDateRangeContextProvider } from "./components/contextAPIs/DateNDateRangePicker.js";
import { UserAttendanceDashboardV2 } from "./components/DashBoard/UserAttendanceDashboard.v2.jsx";
import { AttendancePdfv2 } from "./components/Students/AttendancePdf.v2.jsx";
import { AttendanceSheetFormat } from "./components/Utils/AttendanceSheetFormat.jsx";
import { MBStudentsAttendanceDashboard } from "./components/Students/MBStudentsAttendanceDashboard.jsx";
import { StudentAbsenteeCallingV2 } from "./components/Students/StudentAbsenteeCalling.v2.jsx";
import { MBMarksUpload } from "./components/Students/MBMarksUpload.jsx";
import { MBStudentCopyChecking } from "./components/Students/MBStudentCopyChecking.jsx";
import { MBStudentCopyCheckingDashboard } from "./components/Students/MBStudentCopyCheckingDashboard.jsx";
import { DownloadMBStudentAttendance } from "./components/Utils/DownloadMBStudentAttendnace.jsx";
import {CreateStudentBulk} from "./components/Admin/CreateStudent.jsx";
import { UpdateStudentBulk } from "./components/Admin/UpdateStudent.jsx";
import { UploadBillsV2 } from "./components/Bills/UploadBills.v2.jsx";
import { ViewBillsV2 } from "./components/Bills/ViewBills.v2.jsx";
import { BillsVerificationV2 } from "./components/Bills/BillsVerification.v2.jsx";
import { BillsApprovalV2 } from "./components/Bills/BillsApproval.v2.jsx";
import { SchoolDisciplinaries } from "./components/Centers/SchoolDisciplinaries.jsx";
import { ClaimGamificationPoint, ClaimGamificationPointS } from "./components/Gamification/ClaimGamificationPoint.jsx";
import { StudentsUpload } from "./components/Students/StudentsUpload.jsx";
import { StudentsUploadDashboard } from "./components/DashBoard/StudentUploadDashboard.jsx";
import { StudentUploadObjectiveDashboard } from "./components/DashBoard/StudentUploadObjectivesDashboard.jsx";
import { MBStudentsAbsenteeCallingDashboard } from "./components/Students/MBStudentsAbsenteeCallingDashboar.jsx";
import { CreateStudentForm } from "./components/Admin/CreateStudentForm.jsx";
import { RemoveOrReleaseSLC } from "./components/Admin/RemoveOrReleaseSLC.jsx";
import { GamificationDashboardV2 } from "./components/Gamification/GamificationDashboard.v2.jsx";
import { StudentsV2 } from "./components/Students/Students.v2.jsx";
import { DownloadStudentsData } from "./components/Utils/DownloadStudents.jsx";
import { StudentAddRequest } from "./components/Admin/StudentAddRequest.jsx";
import { StudentRemoveSLCRequest } from "./components/Admin/RemoveSLCRequest.jsx";
import { UserSelfAttendanceDashboard } from "./components/DashBoard/UserSelfAttendanceDashboard.jsx";
import { TimeTable } from "./components/Academics/TimeTable.jsx";
import { LectureVideos } from "./components/Academics/LectureVideos.jsx";
import { CertificateGenerator } from "./Admin/GENERATETEMPLATE.jsx";
import ViewTimeTable from "./components/Academics/ViewTimeTable.jsx";
import ViewLectureVideos from "./components/Academics/ViewLecturVideos.jsx";
import { CreateGamificationUsers } from "./components/Admin/CreateGamificationUsers.jsx";
import { InititaeGamificationRank } from "./components/Admin/InitiateGamificationRanking.jsx";
import { DPR } from "./components/Admin/DPR.jsx";
import DPRStatus from "./components/Admin/DPRStatus.jsx";
import DPRReport from "./components/Admin/DPRReport.jsx";
import { FormMain } from "./Callings/FormMain.jsx";
import { FormDashboardByUserId } from "./Callings/FormDashboardUserId.jsx";

function App() {
  
  
  return (
    <>
   
      <Router>
        
        <SliderProvidedr>
          <DistrictBlockSschoolContextV2Provider>
            <DateNDateRangeContextProvider>
          <DistrictBlockSchoolProvider>
            <DistrictProvider>
            <BlockProvider>
              <SchoolProvider>
                <ClassOfStudentProvider>
                  <UserProvider>
                 
                    <Routes>
                      <Route path="/" element={<UserSignIn />} />
                      
                      <Route path="/forgot-password" element = {<ForgotPassword/>}/>
                      
                      <Route path="/user-signup" element = {<UserSignup/>}/>

                      <Route element = {<LayoutWithNewNavbar/>}> 
                      
                      <Route path="/user-dash" element={<MainLayout />} />
                      
                      <Route path="/l2-user-dash" element = {<MainLayoutAciLevel/>}/>  
                      
                      <Route path="/l3-user-dash" element = {<MainLayoutManagerLevel/>}/>  
                      
                      {/* <Route path="/l0-user-dash" element = {<OfficeCommunityTeam/>}/>                     */}

                      <Route path="/l0-user-dash" element={<MainLayoutOfficeLevel/>}/>

                      <Route path="/tech-dash" element = {<TechConcernsLayout/>}/>

                      <Route path="/user-profile" element = {<UserProfile/>}/>



                      {/* Acadmecis routes */}
                      <Route path="/mb-attendance" element={<AttendanceMB />} />
                      <Route path="/upload-marks" element={<UploadMarks />} />
                      <Route path="/student-disciplinary-or-interaction" element={<StudentDisciplinaryOrInteraction />}/>
                      <Route path="/copy-checking" element={<CopyChecking />}/>
                      <Route path="/manual-attendance" element={<ManualAttendance />}/>

                      <Route
                        path="/upload-attendance-pdf"
                        element={<AttendancePdf />}
                      />

                      {/* download module */}

                      <Route
                        path="/attendance-pdf-format"
                        element={<DownloadAttendancePdfFormat />}
                      />

                      {/* Bills moudle */}
                      <Route path="/upload-bills" element={<BillsPage />} />
                          <Route
                        path="/verify-bills"
                        element={<BillsVerificationPage />}
                      />

                      <Route path="/bill-dashboard" element={<BillDashboard />} />

                      <Route path="/bills-pending-verification" element={<MainBillPage/>}/>
                      <Route path="/verified-rejected-bills" element = {<VerifiedAndRejectedBills/>}/>

                      {/* Monitoring module */}
                      <Route
                        path="/center-disciplinary-or-interaction"
                        element={<MbCentersDisciplinary />}
                      />
                      {/* Admin module */}
                      {/* Below will be accessible to admin only */}
                      <Route path="/admin-dash" element = {<AdminLayout/>}/>
                      <Route
                        path="/test-controller"
                        element={<TestController />}
                      />

                      <Route
                        path="/initiate-test"
                        element={<CreateTest_Admin />}
                      />
                      <Route
                        path="/initiate-user-attendance"
                        element={<CreateEmpAttendanceData />}
                      />

                      <Route
                        path="/initiate-student-attendance"
                        element={<CreateStudentAttendanceData />}
                      />

                      
                      <Route
                        path="/create-user"
                        element={<CreateUser/>}
                      />


                      <Route path="/update-user"
                      element = {<UpdateUser/>}/>



                      <Route path="/user-dashboard" element = {<UserMainLayout/>}/>


                      {/* calling module */}
                      <Route
                        path="/student-callings"
                        element={<StudentRelatedCallings />}
                      />

                      <Route
                        path="/absentee-calling"
                        element={<AbsenteeCalling />}
                      />

                      <Route path="/absent-calling" element = {<AbsentCalling/>}/>

                      <Route
                        path="/initiate-upload-attendance-pdf"
                        element={<CreateUploadAttendancePdf />}
                      />

                     

                      {/* Concerns module */}

                      {/* <Route path="/school-concerns" element = {<SchoolConcernsForm/>}/> */}
                    <Route path="/school-concerns" element = {<SchoolConcerns/>}/>
                      
                    <Route path="/tech-concerns" element = {<TechConcerns/>}/>
                     
                    <Route path="/tech-concerns-resolution" element = {<TechConcernsResolution/>}/>
                      
                    <Route path="/tech-concerns-status" element = {<TechConcernsStatus/>}/>
                     
                    <Route path="/tech-concerns-status" element = {<TechConcernsStatus/>}/>
                     
                    <Route path ="/individual-concerns-form" element = {<IndividualConcerns/>}/>
                      
                    <Route path="/individual-leave-requests" element = {<IndividualLeaveRequests/>}/>
                      
                    <Route path="/individual-concerns-resolution" element = {<IndividualConcenrsResolution/>}/> 
                      
                    <Route path="/self-cocnerns-resolution" element = {<IndividualConcernsRequest/>}/>

                    <Route path="/school-concerns-request" element = {<SchoolConcernsRequest/>}/> 


                    <Route path="/attendance-user" element = {<UserAttendance/>}/>
                  
                  <Route path="/user-attendance-updated" element = {<UserAttendanceUpdated/>}/>
                  
                  <Route path="/user-attendance-aci" element = {<UserAttendanceACI/>}/>
                    
                      {/* Dashboard */}
                      <Route path="/student-attendance-dashboard" element = {<StudentAttendanceDashBoard/>}/>
                      <Route path="/student-calling-dashboard" element = {<StudentCallingDashBoard/>}/>
                       <Route path="/attendance-pdf-count-dashboard" element = {<AttendancePdfCount/>}/>
                      {/* <Route path="/user-attendance-dashboard" element = {<UserAttendanceDash/>}/>           */}
                      
                      <Route path="/student-disciplinary-dashboard" element = {<StudentDisciplinaryDashboard/>}/>



                      {/* Gamification */}
                      <Route path="/gamification-disciplinary" element ={<GamificationDisciplinary/>}/>

                      <Route path="/s100-attendance" element ={<S100Attendances/>}/>


                      <Route path="/award-points" element = {<Gamification/>}/>


                        <Route path="/gamification-dashboard" element = {<GamificationDashboard/>}/>

                      
                        {/* ERP Test */}

                  < Route path="/erp-test" element = {<ERPtest/>}/>

                  {/* testfile upload */}

                  <Route path="/student-test-file-09" element = {<StudentTestFileUpload/>}/>

                  <Route path="/ta-verification-data" element = {<TaVerification/>}/>

                    {/* Admin: Edit user access */}

                    <Route path="/edit-user-access" element = {<EditUserAccess/>}/>
                    <Route path="/edit-user" element = {<EditUser/>}/>




                    <Route path="/calling" element = {<Calling/>}/>

                    <Route path="/calling-main" element = {<CallingMain/>}/>

                    <Route path="/form-main" element = {<FormMain/>}/>

                    <Route path="/create-objective-of-calling" element = {<CreateObjectiveOfCalling/>}/>

                  
                    <Route path="/calling-dashboard-objective-of-calling" element = {<CallingDashboardByUserId/>}/>

                   <Route path="/form-dashboard-objective-of-calling" element = {<FormDashboardByUserId/>}/>


                      <Route path="/ame-score-card-202527" element = {<AMEScoreCard202527/>}/>

                      {/* <Route path="/ame-attendance-sheet" element = {<AMEAttendanceSheet/>}/> */}
                       <Route path="/focus-200-attendance-sheet" element = {<AMEAttendanceSheet/>}/>

                      {/* <Route path="/ame-admit-card" element = {<AMEAdmitCard/>}/> */}
                       <Route path="/focus-200-admit-card" element = {<AMEAdmitCard/>}/>

                       <Route path="/calling-dasbhaord-of-all-users"  element = {<CallingDashboardOfAllUsers/>}/>


                       {/* version 2 New route */}



                       <Route path="/mark-user-attendance" element={<MarkUserAttendance/>}/>

                       {/* student */}

                       <Route path="/mb-student-attendance" element = {<MBStudentsAttendanceV2/>}/> 

                        {/* dashboard routes */}

                        <Route path="/user-attendance-dashboard" element = {<UserAttendanceDashboardV2/>}/>


                          <Route path="/attendance-pdf" element = {<AttendancePdfv2/>}/>


                        <Route path="/attendance-sheet-format" element = {<AttendanceSheetFormat/>}/>

                        <Route path="/mb-student-attendance-dashboard" element= {<MBStudentsAttendanceDashboard/>}/>  


                        <Route path="/student-absentee-calling" element = {<StudentAbsenteeCallingV2/>}/>

                        <Route path="/mb-marks-upload" element = {<MBMarksUpload/>}/>

                        <Route path="/mb-student-copy-checking" element = {<MBStudentCopyChecking/>}/>

                        <Route path="/mb-student-copy-checking-dashboard" element = {<MBStudentCopyCheckingDashboard/>}/>

                        <Route path="/download-mb-student-attendance" element = {<DownloadMBStudentAttendance/>}/>


                        <Route path="/create-student" element = {<CreateStudentBulk/>}/>

                         <Route path="/update-student" element = {<UpdateStudentBulk/>}/>


                        <Route path="/upload-bills-v2" element = {<UploadBillsV2/>}/>


                        
                        <Route path="/view-bills-v2" element = {<ViewBillsV2/>}/>

                            <Route path="/bills-verification-v2" element = {<BillsVerificationV2/>}/>

                             <Route path="/bills-approval-v2" element = {<BillsApprovalV2/>}/>



                             <Route path="/school-disciplinaries" element = {<SchoolDisciplinaries/>}/>


                            <Route path="/claim-gamification-point" element = {<ClaimGamificationPointS/>}/>


                            <Route path="/student-upload" element = {<StudentsUpload/>}/>


                            <Route path="/student-upload-dashboard" element = {<StudentsUploadDashboard/>}/>

                            <Route path="/student-upload-objectives-dashboard" element = {<StudentUploadObjectiveDashboard/>}/>


                           <Route path="/mb-student-absentee-calling-dashboard" element = {<MBStudentsAbsenteeCallingDashboard/>}/>

                    <Route path="/create-student-form" element = {<CreateStudentForm/>}/>

                    <Route path="/remove-or-release-slc" element = {<RemoveOrReleaseSLC/>}/>

                      <Route path="/gamification-dashboard-v2" element = {<GamificationDashboardV2/>}/>


 
                      <Route path="/students-v2" element = {<StudentsV2/>}/>

                      <Route path="/download-students-data" element = {<DownloadStudentsData/>}/>


                      <Route path="/student-add-request" element = {<StudentAddRequest/>}/>


                       <Route path="/student-remove-slc-request" element = {<StudentRemoveSLCRequest/>}/>


                       <Route path="/user-self-attendance-dashboard" element = {<UserSelfAttendanceDashboard/>}/>

                        <Route path="/create-time-table" element = {<TimeTable/>}/>

                         <Route path="/create-lecture-videos" element = {<LectureVideos/>}/>

          <Route path="/certificate-generator" element = {<CertificateGenerator/>}/>

        

          <Route path="/view-time-table" element = {<ViewTimeTable/>}/>

   <Route path="/view-lecture-videos" element = {<ViewLectureVideos/>}/>

   <Route path="/create-gamification-users" element = {<CreateGamificationUsers/>}/>

         <Route path="/initiate-gamification-rank" element = {<InititaeGamificationRank/>}/>

         <Route path="/daily-work-report" element = {<DPR/>}/>

    <Route path="/admin/dpr-status/:taskId" element={<DPRStatus/>} />
<Route path="/admin/dpr-report" element={<DPRReport />} />
                      </Route>
                    </Routes>
                  </UserProvider>
                </ClassOfStudentProvider>
              </SchoolProvider>
            </BlockProvider>
            </DistrictProvider>
          </DistrictBlockSchoolProvider>
          </DateNDateRangeContextProvider>
          </DistrictBlockSschoolContextV2Provider>
        </SliderProvidedr>
      </Router>
    </>
  );
}

export default App;
